<div class="input_checkbox" *ngIf="!expertMode && showVereinbarungKommunikation">
  <mat-checkbox [formControl]="vereinbarungKommunikation">
    <div>
      {{ !antrag ? 'Ich möchte bei der HDI Versicherung AG beratungsfrei online Prämien berechnen und bin ausdrücklich damit einverstanden, die Dokumente zum Angebot per E-Mail zu erhalten. *' :
      'Ich möchte bei der HDI Versicherung AG beratungsfrei online den Vertrag abschließen und bin ausdrücklich damit einverstanden, die Dokumente zum Antrag per E-Mail zu erhalten. *'  }}
    </div>
  </mat-checkbox>
  <mat-error *ngIf="vereinbarungKommunikation.hasError('required') && (vereinbarungKommunikation.touched || parentFormGroupDirective.submitted)">{{ 'CONFIRMREQUIRED' | translate }}</mat-error>
</div>
